import { pay_manage_http } from '@/libs/util'
import util from '@/libs/util'
export const { 
    export_wage_record
 } = util.api || {}

export function getExportWageRecordApi(params) {
    return pay_manage_http.get(export_wage_record, {
            ...params,
            no_need_fail_modal:true,
            no_need_fail_catch_modal:true
        })
}